import React from 'react';
import style from './ChartModeButton.module.css';

function ChartModeButton({children, mode, activeMode, setActiveMode, ...props}) {

    const className = mode === activeMode ? style.active : style.main

    return (
        <button
            className={className}
            {...props}
            onClick={() => setActiveMode(mode)}
        >
            {children}
        </button>
    )
}

export default ChartModeButton;